import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
// import './index.css';
// import './bootstrap.min.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import GoogleOAuthBoundary from './config/GoogleOAuthBoundary';
import { ThemeProvider } from './contexts/ThemeContext';
import { NavigationProvider } from './contexts/NavigationContext';
import ErrorBoundary from './components/ErrorBoundary';
import { installReleaseIdentity } from './telemetry/releaseIdentity';
import { registerServiceWorker } from './pwa/registerServiceWorker';

installReleaseIdentity();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthBoundary>
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider>
          <NavigationProvider>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </NavigationProvider>
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  </GoogleOAuthBoundary>
);

// Non-blocking PWA installability registration (production only).
registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();